class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.timer = null; 
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.mainDetailsToggle.addEventListener(
      'mouseover',
      this.onSummaryHover.bind(this)
    );
   
    document.body.addEventListener(
      'mouseover',
      this.onSummaryHoverOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }
  closeOthers(event) {
     var inputsObj  =document.querySelectorAll("header-menu");
     //inputsObj = customElements.get("header-menu")
     //console.log(inputsObj)
     for(var i = 0; i<inputsObj.length;i++){
       if(inputsObj[i] !== event.target.closest('header-menu')){
       	inputsObj[i].querySelector("details").removeAttribute('open');
        inputsObj[i].querySelector('summary').setAttribute('aria-expanded', false);
       }
     }
   
  }
  onBodyOutEvent(event){

    var open_detail = document.querySelector(".menu_new details[open]").closest("details");
    open_detail.removeAttribute('open');
    open_detail.querySelector('summary').nextElementSibling.setAttribute('aria-expanded', false);
  }
  onSummaryHoverOut(event){
     clearTimeout(this.timer);
   if(
     (event.target.closest('header-menu') && event.target.closest('header-menu').classList.contains('menu_new'))
     || event.target.classList.contains("mega-menu__content")
     || (event.target.closest('nav.header__inline-menu') && !event.target.closest('li'))
    ){


    }
    else{

        this.timer = setTimeout(function(){
          var elem = document.querySelector(".menu_new details[open]");
          if(elem){
            var open_detail = elem.closest("details");
            open_detail.removeAttribute('open');
            open_detail.querySelector('summary').nextElementSibling.setAttribute('aria-expanded', false);

             if(document.querySelector("#MainContent"))
               document.querySelector("#MainContent").classList.remove('OverlayBackgroundMega');

          }
        }, 200);

    }
  }
   onSummaryHover(event) {
	clearTimeout(this.timer);
    event.preventDefault();
    if(event.target.closest('header-menu').classList.contains('menu_new')){
      	//event.target.closest('header-menu').classList.add("Yoo")
    	this.open(event);
    }
  }
  
  open(event){

      this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);

      // When switching between mega menus, force the entering panel to
      // appear instantly via inline styles (prevents flicker from the
      // opacity 0→1 transition while the old panel is closing).
      const isMegaMenu = this.mainDetailsToggle.classList.contains('mega-menu');
      const anotherMegaOpen = isMegaMenu && document.querySelector('details.mega-menu[open]');
      if (anotherMegaOpen && this.content) {
        this.content.style.setProperty('transition', 'none', 'important');
        this.content.style.opacity = '1';
        this.content.style.visibility = 'visible';
      }

      this.mainDetailsToggle.setAttribute('open','open');
      this.closeOthers(event);

      // Set up visual appearance synchronously (before paint) so arrow
      // visibility and opacity are correct on the very first frame.
      // Actual Swiper creation is deferred to the toggle handler.
      if (isMegaMenu && window.__megaInitSwipers) {
        if (window.__megaInitSwipers(this.mainDetailsToggle)) {
          this.mainDetailsToggle._swiperInitDone = true;
        }
      }

      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      document.body.addEventListener('click', this.onBodyClickEvent);
      //document.body.addEventListener('mouseover', this.onBodyOutEvent);
     if(document.querySelector("#MainContent"))
       document.querySelector("#MainContent").classList.add('OverlayBackgroundMega');

      // Clear inline styles after two frames so future transitions work
      if (anotherMegaOpen && this.content) {
        const content = this.content;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            content.style.removeProperty('transition');
            content.style.removeProperty('opacity');
            content.style.removeProperty('visibility');
          });
        });
      }
  }
  
  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }
  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false); 
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);